const IMAGES = ["/assets/wirtualne-biuro-warszawa-mokotow-3.jpg", "/assets/wirtualne-biuro-warszawa-mokotow-1.jpg", "/assets/wirtualne-biuro-warszawa-mokotow-2.jpg"];

export default function Background() {
  return (
    <div data-testid="site-background" aria-hidden="true" className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      {IMAGES.map((src, i) => (
        <div
          key={src}
          className="bg-slide absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${src})`, animationDelay: `${i * 14}s` }}
        />
      ))}
      <div className="absolute inset-0 bg-background/75 dark:bg-background/85" />
      <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-transparent to-background/70" />
      <div className="absolute inset-0 bg-grain" />
    </div>
  );
}
